<template>
  <div>
    <load-profile />
    <b-card>
      <validation-observer
        ref="createForm"
        #default="{ invalid }"
      >
        <n-form-confirmation
          key="createForm"
          :form="$refs.createForm"
          :disabled="invalid"
          :message="contactType === 'phone' ? 'alert.savePhone' : 'alert.areYouSureSendInviation'"
          :confirm-button-text="contactType=== 'phone' ? 'button.confirm' : 'button.sendInvitation'"
          @submit="submit"
        >
          <b-form-group class="mb-0">
            <b-form-radio-group v-model="contactType">
              <b-form-radio
                value="email"
              >
                {{ $t('general.use_portal') }}
              </b-form-radio>
              <b-form-radio
                value="phone"
                class="mb-1"
              >
                {{ $t('general.use_telegram') }}
              </b-form-radio>
            </b-form-radio-group>
            <div
              class="p-1"
              style="border-radius: 0.5rem;
              background: #f8f8f8;
            "
            >
              <small style="color: #898989;">{{ contactType === 'email' ? $t('general.use_portal_hint') : $t('general.use_telegram_hint') }}</small>
            </div>
          </b-form-group>
          <b-row>
            <template v-if="contactType === 'phone'">
              <b-col
                cols="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('field.phone')"
                  vid="phone"
                  rules="required"
                >
                  <b-form-group
                    class="mt-1"
                    style="color: #6e6b7b"
                  >
                    <div class="col-form-label pt-0">
                      <span>{{ $t('field.phone') }}</span>
                    </div>
                    <n-tel-input
                      v-model="data.phone"
                      name="phone"
                      :placeholder="$t('field.phone')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="6">
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('field.role')"
                  :vid="data.roleId"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('field.role')"
                    class="mt-1"
                  >
                    <n-async-single-select
                      v-model="data.roleId"
                      repository="role"
                      selection-key="id"
                      selection-label="translations"
                      :state="errors.length === 0 ? null : false"
                      :placeholder="$t('field.role')"
                      :immediate="false"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col
                cols="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('field.firstName')"
                  vid="firstName"
                  rules="required"
                >
                  <b-form-group
                    class="mt-1"
                    style="color: #6e6b7b"
                  >
                    <div class="col-form-label pt-0">
                      <span>{{ $t('field.firstName') }}</span>
                    </div>
                    <b-form-input
                      v-model="data.firstName"
                      name="firstName"
                      :placeholder="$t('field.firstName')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="6"
              >
                <validation-provider
                  v-slot="{ errors }"
                  :name="$t('field.lastName')"
                  vid="lastName"
                  rules="required"
                >
                  <b-form-group
                    class="mt-1"
                    style="color: #6e6b7b"
                  >
                    <div class="col-form-label pt-0">
                      <span>{{ $t('field.lastName') }}</span>
                    </div>
                    <b-form-input
                      v-model="data.lastName"
                      name="lastName"
                      :placeholder="$t('field.lastName')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </template>

            <b-col
              v-if="contactType === 'email'"
              cols="6"
            >
              <validation-provider
                v-slot="{ errors }"
                :name="$t('field.email')"
                vid="email"
                :rules="{
                  required: true,
                  email: true,
                  max: 100
                }"
              >
                <b-form-group
                  class="mt-1"
                  style="color: #6e6b7b"
                >
                  <div class="col-form-label pt-0">
                    <span>{{ $t('field.email') }}</span>
                  </div>
                  <b-form-input
                    v-model="data.email"
                    :placeholder="$t('field.email')"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              v-if="contactType === 'email'"
              cols="6"
            >
              <validation-provider
                v-slot="{ errors }"
                :name="$t('field.role')"
                :vid="data.roleId"
                rules="required"
              >
                <b-form-group
                  :label="$t('field.role')"
                  class="mt-1"
                >
                  <n-async-single-select
                    v-model="data.roleId"
                    repository="role"
                    selection-key="id"
                    selection-label="translations"
                    :state="errors.length === 0 ? null : false"
                    :placeholder="$t('field.role')"
                    :immediate="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              v-if="contactType !== 'phone'"
              cols="6"
            >
              <validation-provider
                v-slot="{ errors }"
                :name="$t('general.chat_cap')"
                rules="required|numeric|min_value:0"
              >
                <b-form-group
                  :label="$t('general.chat_cap')"
                  class="mt-1"
                >
                  <b-form-input
                    v-model="data.serviceCap"
                    :placeholder="$t('general.chat_cap')"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <div class="compact-container">
              <p class="mb-0 font-weight-bold">
                {{ $t('general.department_and_team') }}
              </p>
              <div
                v-for="(param, paramIndex) in data.departmentAndTeam"
                :key="paramIndex"
                class="compact-card"
              >
                <div class="key">
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('breadcrumb.department')"
                    rules="required"
                  >
                    <b-form-group
                      :label="$t('breadcrumb.department')"
                      class="mt-1"
                      style="color: #6e6b7b"
                    >
                      <n-async-single-select
                        v-model="param.departmentId"
                        repository="department"
                        selection-key="id"
                        clearable
                        :placeholder="$t('breadcrumb.department')"
                        selection-label="translations"
                        :state="errors.length > 0 ? 'is-invalid' : null"
                        :must-excluded-ids="data.departmentAndTeam.map(item => item.departmentId).filter(id => id !== param.departmentId)"
                        :immediate="false"
                        @input="param.teamId = []"
                      />
                    </b-form-group>
                  </validation-provider>
                </div>
                <div class="value">
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('breadcrumb.team')"
                  >
                    <b-form-group
                      class="mt-1"
                      style="color: #6e6b7b"
                    >
                      <div class="col-form-label pt-0">
                        <span>{{ $t('breadcrumb.team') }}</span>
                        <span class="text-muted"> - {{ $t('field.optional') }}</span>
                      </div>
                      <n-async-multi-select
                        :key="param.departmentId"
                        v-model="param.teamId"
                        repository="team"
                        selection-key="id"
                        :placeholder="$t('breadcrumb.team')"
                        selection-label="translations"
                        :readonly="!param.departmentId"
                        always-fresh
                        :query="{
                          departmentId: param.departmentId,
                        }"
                        :state="errors.length > 0 ? 'is-invalid' : null"
                        :immediate="false"
                        @input="onChange"
                      />
                    </b-form-group>
                  </validation-provider>
                </div>
                <div
                  v-if="data.departmentAndTeam.length > 1"
                  class="delete-btn"
                >
                  <b-button
                    variant="danger"
                    pill
                    size="sm"
                    style="padding: 5px;"
                    @click="removeParameter(paramIndex)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </div>
              </div>

              <b-button
                variant="outline-secondary"
                size="sm"
                style="width: fit-content;"
                @click="addParameter()"
              >
                <feather-icon icon="PlusIcon" />
                {{ $t('button.add') }}
              </b-button>
            </div>

            <div class="compact-container">
              <div class="switch-container operator">
                <validation-provider>
                  <b-form-group
                    class="mt-1"
                  >
                    <b-form-checkbox
                      v-model="data.isAllowedOperatingService"
                      :value="true"
                      :unchecked-value="false"
                      :switch="true"
                    >
                      {{ $t('field.allow_operating_service') }}
                    </b-form-checkbox>
                    <small class="text-muted">{{ $t('field.allow_operating_service_hint') }}</small>
                  </b-form-group>
                </validation-provider>
                <div
                  v-if="data.isAllowedOperatingService"
                  class="operation-container"
                >
                  <div style="display: flex; gap: 1rem;">
                    <b-col cols="6">
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('breadcrumb.project')"
                        rules="required"
                      >
                        <b-form-group
                          style="color: #6e6b7b"
                        >
                          <div class="col-form-label pt-0">
                            <span>{{ $t('breadcrumb.project') }}</span>
                          </div>
                          <n-async-multi-select
                            v-model="data.projects"
                            repository="project"
                            selection-key="id"
                            :placeholder="$t('breadcrumb.project')"
                            selection-label="translations"
                            is-object
                            always-fresh
                            :state="errors.length > 0 ? 'is-invalid' : null"
                            :immediate="false"
                            clearable
                            included-all
                            all-option-value="ALL_PROJECT"
                          />
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </div>

                  <div class="compact-container">
                    <p class="mb-0 font-weight-bold">
                      {{ $t('general.service_category_and_type') }}
                    </p>
                    <div
                      v-for="(param, paramIndex) in data.serviceCateAndType"
                      :key="paramIndex"
                      class="service-compact-card"
                    >
                      <div class="key">
                        <validation-provider
                          v-slot="{ errors }"
                          :name="`param${paramIndex}Name`"
                          rules="required"
                        >
                          <b-form-group
                            class="mt-1"
                            style="color: #6e6b7b"
                          >
                            <div class="col-form-label pt-0">
                              <span>{{ $t('breadcrumb.serviceCategory') }}</span>
                            </div>
                            <n-async-multi-select
                              v-model="param.serviceCategory"
                              clearable
                              repository="serviceCategory"
                              :placeholder="$t('breadcrumb.serviceCategory')"
                              selection-key="code"
                              selection-label="translations"
                              :is-object="true"
                              :state="errors.length > 0 ? 'is-invalid' : null"
                              :immediate="false"
                              always-fresh
                              included-all
                              no-excluded
                              all-option-value="ALL_CATEGORY"
                              @input="onCategoryChange(paramIndex)"
                            />
                          </b-form-group>
                        </validation-provider>
                        <span class="value" />
                      </div>
                      <div class="value">
                        <div class="service-type-container">
                          <validation-provider
                            v-slot="{ errors }"
                            :name="`param${paramIndex}Key`"
                            rules="required"
                          >
                            <b-form-group
                              class="mt-1"
                              style="color: #6e6b7b"
                            >
                              <div class="col-form-label pt-0">
                                <span>{{ $t('breadcrumb.serviceType') }}</span>
                              </div>
                              <n-async-multi-select
                                :key="resetIndex"
                                v-model="param.serviceTypes"
                                repository="serviceType"
                                selection-key="code"
                                clearable
                                :placeholder="$t('breadcrumb.serviceType')"
                                selection-label="translations"
                                :state="errors.length > 0 ? 'is-invalid' : null"
                                :readonly="!param.serviceCategory || (Array.isArray(param.serviceCategory) && param.serviceCategory.length === 0)"
                                :is-object="true"
                                included-all
                                all-option-value="ALL_TYPE"
                                :query="getQuery(param.serviceCategory)"
                                always-fresh
                                :immediate="false"
                                group-key="service"
                                @input="onServiceTypeChange(paramIndex)"
                              />
                            </b-form-group>
                          </validation-provider>
                          <validation-provider
                            v-slot="{ errors }"
                            :name="`param${paramIndex}Key`"
                            rules="required"
                          >
                            <b-form-group
                              class="mt-1"
                              style="color: #6e6b7b"
                            >
                              <div class="col-form-label pt-0">
                                <span>{{ $t('breadcrumb.serviceSubType') }}</span>
                              </div>
                              <n-async-multi-select
                                :key="resetSubIndex"
                                v-model="param.serviceSubTypes"
                                repository="serviceSubType"
                                selection-key="code"
                                selection-label="translations"
                                clearable
                                :placeholder="$t('breadcrumb.serviceSubType')"
                                :state="errors.length > 0 ? 'is-invalid' : null"
                                :readonly="!param.serviceTypes || (Array.isArray(param.serviceTypes) && param.serviceTypes.length === 0)"
                                :is-object="true"
                                included-all
                                all-option-value="ALL_SUBTYPE"
                                :query="getSubTypeQuery(param.serviceCategory, param.serviceTypes)"
                                always-fresh
                                group-key="type"
                                :immediate="false"
                              />
                            </b-form-group>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="compact-container">
                    <div class="switch-container">
                      <validation-provider>
                        <b-form-group>
                          <b-form-checkbox
                            v-model="data.isAutoAssignService"
                            :value="true"
                            :unchecked-value="false"
                            :switch="true"
                          >
                            {{ $t('field.allow_auto_assign_service') }}
                          </b-form-checkbox>
                          <small class="text-muted">{{ $t('field.allow_auto_assign_service_hint') }}</small>
                        </b-form-group>
                      </validation-provider>
                    </div>

                    <b-col
                      v-if="data.isAutoAssignService"
                      cols="6"
                    >
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('field.serviceCap')"
                        rules="required|numeric|min_value:0"
                      >
                        <b-form-group
                          :label="$t('field.serviceCap')"
                        >
                          <b-form-input
                            v-model="data.totalServiceCap"
                            :placeholder="$t('field.serviceCap')"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </div>
                </div>
              </div>
            </div>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <n-button-loading
                v-if="$can('create', permissionType)"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="submit"
                class="mt-1 mr-1"
                variant="primary"
                :loading="loading"
                :disabled="invalid || !isValidDepartments"
              >
                {{ contactType === 'phone' ? $t('button.save') : $t('button.sendInvitation') }}
              </n-button-loading>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                class="mt-1"
                @click="back"
              >
                {{ $t('button.cancel') }}
              </b-button>
            </b-col>
          </b-row>
        </n-form-confirmation>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardHeader,
  BCardTitle,
  BLink,
  BFormRadioGroup,
  BFormCheckbox,
  BButton,
  BFormRadio,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import Ripple from 'vue-ripple-directive'
import NButtonLoading from '@/components/NButtonLoading'
import NFormConfirmation from '@/components/NFormConfirmation'
import NInput from '@/components/NInput'
import NTable from '@/components/NTable'
import { mapValidationMessage } from '@/libs/helper'
import NAsyncSingleSelect from '@/components/NAsyncSingleSelect'
import NAsyncMultiSelect from '@/components/NAsyncMultiSelect'
import { readonly } from '@vue/composition-api'
import NTelInput from '@/components/NTelInput'
import formInput from './formInput'

const OperatorRepository = Repository.get('operator')

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardHeader,
    BCardTitle,
    BLink,
    BFormRadioGroup,
    BFormCheckbox,
    NButtonLoading,
    NFormConfirmation,
    NInput,
    NTable,
    NAsyncSingleSelect,
    NAsyncMultiSelect,
    BButton,
    NTelInput,
    BFormRadio,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        email: null,
        roleId: null,
        serviceCap: '5',
        totalServiceCap: '5',
        phone: null,
        firstName: null,
        lastName: null,
        projects: [],
        departmentAndTeam: [
          {
            departmentId: '',
            teamId: '',
          },
        ],
        serviceCateAndType: [
          {
            serviceCategory: [],
            serviceTypes: [],
            serviceSubTypes: [],
          },
        ],
        isAllowedOperatingService: false,
        isAutoAssignService: false,
      },
      loading: false,
      contactType: 'email',
      resetIndex: 0,
      resetSubIndex: 0,
    }
  },
  computed: {
    isValidDepartments() {
      return this.data.departmentAndTeam.every(item => item.departmentId !== '' && item.departmentId !== null)
    },
    fieldsComputed() {
      const a = formInput.map(field => {
        if (field.key === 'teamId') {
          field.disabled = !this.data.departmentId
        }
        if (field.key === 'serviceType') {
          field.disabled = !this.data.serviceCategoryCode
        }
        return field
      })
      return a
    },
  },
  watch: {
    contactType(value) {
      this.data.isAllowedOperatingService = value !== 'email'
    },
  },
  methods: {
    getQuery(data) {
      if (!data || data?.length === 2 || data?.some(e => e.code === 'ALL_CATEGORY')) return {}
      return {
        serviceCategoryCode: (data || []).map(e => e.code).join(','),
      }
    },
    getSubTypeQuery(serviceCategoryCode, serviceTypeCode) {
      return {
        serviceCategoryCodes: (serviceCategoryCode || []).map(e => e.code).join(','),
        serviceTypeCodes: (serviceTypeCode || []).map(e => e.code).join(','),
      }
    },
    getExcludedCodes(index) {
      console.log(this.data.serviceCateAndType, index)
      const a = this.data.serviceCateAndType
        .filter((_, i) => i !== index)
        .map(item => item.serviceCategory?.code)

      console.log(a)
    },
    getKey(data, index) {
      return data?.id || `key-${index}`
    },
    onDepartmentChange() {
      // console.log('department change', value)
    },
    createDefaultParameter(key = 'departmentAndTeam') {
      if (key === 'serviceCateAndType') {
        return {
          serviceCategory: null,
          serviceTypes: [],
          serviceSubTypes: [],
        }
      }
      return {
        departmentId: '',
        teamId: [],
      }
    },
    addParameter(key = 'departmentAndTeam') {
      this.data[key].push(this.createDefaultParameter(key))
    },

    removeParameter(paramIndex, key = 'departmentAndTeam') {
      if (this.data[key].length > 1) {
        this.data[key].splice(paramIndex, 1)
      } else {
        this.$bvToast.toast(this.$t('message.atLeastOneParameter'), {
          variant: 'warning',
        })
      }
    },
    getPramNameError(error, name) {
      if (error) {
        console.log(error.includes(name))
        return error?.includes(name)
          ? error.replace(name, this.$t('field.name'))
          : error
      }
      return ''
    },
    getPramKeyError(error, name) {
      if (error) {
        return error?.includes(name)
          ? error.replace(name, this.$t('field.key'))
          : error
      }
      return ''
    },
    onChange() {
      // console.log(value)
      // this.data.projects = value
    },
    submit() {
      this.$refs.createForm.validate().then(success => {
        if (success) {
          this.save()
        }
      })
    },
    save() {
      // this.loading = true
      // Base payload
      let payload = {
        roleId: this.data.roleId,
        serviceCap: +this.data.serviceCap,
        departmentAndTeam: this.data.departmentAndTeam.map(item => ({
          departmentId: item.departmentId,
          teamId: item.teamId,
        })).filter(item => item.departmentId),
        isAutoAssignService: false,
        totalServiceCap: 5,
      }

      // Add contact info based on type
      if (this.contactType === 'email') {
        payload.email = this.data.email
      } else {
        payload.phone = this.data.phone
        payload.firstName = this.data.firstName
        payload.lastName = this.data.lastName
      }

      // Add service related fields if isAllowedOperatingService is true
      if (this.data.isAllowedOperatingService) {
        payload = {
          ...payload,
          totalServiceCap: +this.data.totalServiceCap,
          isAutoAssignService: this.data.isAutoAssignService,
          projects: this.data.projects.map(project => ({
            projectId: project.id,
            name: project.translationsObj || project.name,
          })),
          serviceCateAndType: this.data.serviceCateAndType
            .filter(category => category.serviceCategory && category.serviceCategory?.length)
            .map(category => {
              // Handle ALL_CATEGORY case
              if (category.serviceCategory.some(cat => cat.code === 'ALL_CATEGORY')) {
                return [{
                  serviceCategoryCode: 'ALL_CATEGORY',
                  serviceTypes: category.serviceTypes.some(type => type.code === 'ALL_TYPE')
                    ? [
                      {
                        code: 'ALL_TYPE',
                        serviceSubTypes: category.serviceSubTypes.some(subType => subType.code === 'ALL_SUBTYPE')
                          ? [{ code: 'ALL_SUBTYPE' }]
                          : (category.serviceSubTypes || [])
                            .map(subType => ({
                              code: subType.code,
                              name: subType.name,
                            })),
                      }]
                    : category.serviceTypes.map(type => ({
                      code: type.code,
                      name: type.name,
                      serviceSubTypes: category.serviceSubTypes.some(subType => subType.code === 'ALL_SUBTYPE')
                        ? [{ code: 'ALL_SUBTYPE' }]
                        : (category.serviceSubTypes || [])
                          .filter(subType => subType.serviceTypeCode === type.code)
                          .map(subType => ({
                            code: subType.code,
                            name: subType.name,
                            serviceTypeCode: subType.serviceTypeCode,
                          })),
                    })),
                }]
              }

              // Handle multiple categories with ALL_TYPE
              const categories = Array.isArray(category.serviceCategory)
                ? category.serviceCategory
                : [category.serviceCategory]

              return categories.map(cat => ({
                name: cat.name,
                serviceCategoryCode: cat.code,
                serviceTypes: category.serviceTypes.some(type => type.code === 'ALL_TYPE')
                  ? [
                    {
                      code: 'ALL_TYPE',
                      serviceSubTypes: category.serviceSubTypes.some(subType => subType.code === 'ALL_SUBTYPE')
                        ? [{ code: 'ALL_SUBTYPE' }]
                        : (category.serviceSubTypes || [])
                          .map(subType => ({
                            code: subType.code,
                            name: subType.name,
                            serviceTypeCode: subType.serviceTypeCode,
                          })),
                    }]
                  : (category.serviceTypes || [])
                    .filter(type => type.serviceCategoryCode === cat.code)
                    .map(type => ({
                      code: type.code,
                      name: type.name,
                      serviceSubTypes: category.serviceSubTypes.some(subType => subType.code === 'ALL_SUBTYPE')
                        ? [{ code: 'ALL_SUBTYPE' }]
                        : (category.serviceSubTypes || [])
                          .filter(subType => subType.serviceTypeCode === type.code)
                          .map(subType => ({
                            code: subType.code,
                            name: subType.name,
                            serviceTypeCode: subType.serviceTypeCode,
                          })),
                    })),
              }))
            }).flat(),
        }
      }

      OperatorRepository.create(payload)
        .then(response => {
          this.$router.push({
            name: `list-${this.route}`,
          })
        })
        .catch(error => {
          if (error.response?.status === 422) {
            const errorMessage = mapValidationMessage(
              error.response.data.validate,
            )
            this.$refs.createForm.setErrors(errorMessage)
          }
        })
        .then(() => {
          this.loading = false
        })
    },
    back() {
      this.$router.back()
    },
    onCategoryChange(index) {
      this.data.serviceCateAndType[index].serviceTypes = []
      this.resetIndex += 1
      // console.log('test value', this.data.serviceCateAndType[index].serviceTypes)
    },
    onServiceTypeChange(index) {
      this.data.serviceCateAndType[index].serviceSubTypes = []
      this.resetSubIndex += 1
    },
  },
  setup() {
    const fields = formInput
    const permissionType = 'manage-users'
    const route = 'operator'
    return { fields, permissionType, route }
  },
}
</script>

<style lang="scss" scoped>
  .compact-container {
    width: 100%;
    border: 1px solid rgba(47, 47, 47, 0.1);
      padding: 1rem;
      margin: 1rem;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      gap: 1rem;

    .compact-card {
      // margin: 1rem 0;
      display: flex;
      align-items: flex-start;
      gap: 1rem;
      .key,.value {
        flex: 1;
      }
    }

    .service-compact-card {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      flex: 1;
      width: 100%;

      .key {
        display: flex;
        align-items: center;
        gap: 1rem;

        span {
          flex: 1;
        }
      }

      .service-type-container {
        display: flex;
        gap: 1rem;

        span {
          flex: 1;
        }
      }
    }
  }

  .delete-btn {
    margin-top: 3.35rem;
  }

  .operation-container {
    width: 100%;
    // border: 1px solid rgba(47, 47, 47, 0.1);
    padding: 1rem;
    // margin: 1rem;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .col-6 {
      flex: none;
      padding: 0;
    }

    .compact-container {
      margin: 0;
      width: unset;
    }
  }

  .switch-container {
    display: flex;
    gap: 1rem;

    &.operator {
      display: flex;
      flex-direction: column;
    }
  }
</style>
